import { useMemo, useState } from 'react'
import AutoPlayRiveComponent from '../AutoPlayRiveComponent'
import BackButton from '../../ui-components/BackButton'
import { goToPortfolioDashboard, trackEvent } from '../../../utils/appBridge'
import { EventNames } from '../../../types/misc.types'
import { getTopPadding } from '../../../utils/sessionStorage'
import { useEliteBuyCtaExtras } from '../EliteBuyCtaExtrasContext'

export const EliteLandingPageLoader = () => {
  const riveRatio = 1.74
  const [outsideRiveWidth, setOutsideRiveWidth] = useState(0)
  const eliteBuyCtaExtras = useEliteBuyCtaExtras()

  const bgRiveheight = useMemo(() => {
    return outsideRiveWidth * (riveRatio ?? 1) || 700
  }, [outsideRiveWidth])

  const handleBack = () => {
    trackEvent({
      eventName: EventNames.UserClicked,
      payload: {
        ...eliteBuyCtaExtras,
        eventId: 'webview_back',
        screenType: 'MF_Elite_Landing'
      }
    })
    goToPortfolioDashboard()
  }

  return (
    <div className='h-screen flex flex-col relative bg-[#010101] w-full'>
      <div
        style={{ top: getTopPadding() }}
        className={`flex absolute left-3 z-10 w-12 h-12 items-center justify-center 
          rounded-[50%] animate-fade-150 bg-[#1C1D1E]  scale-[0.8]`}
      >
        <BackButton fill={'#FFFFFF'} size={24} onClick={handleBack} />
      </div>
      <div className='flex flex-1 h-1 w-full'>
        <div className='h-full overflow-y-scroll no-scrollbar overflow-x-hidden fixed top-0 overscroll-none w-full'>
          <div className='flex flex-col h-max w-full relative z-0'>
            <div className='bg-[#010101] h-screen'>
              <div
                ref={(ref) => {
                  if (ref && outsideRiveWidth === 0) {
                    setOutsideRiveWidth(ref?.clientWidth ?? 300)
                  }
                }}
                style={{ height: bgRiveheight }}
                className='absolute w-full'
              >
                <AutoPlayRiveComponent riveUrl='/elite_bg.riv' riveFit={'fitWidth'} isLoop={true} />
              </div>
            </div>
            <div className='h-[1000px] bg-[#010101] mt-[-600px] z-[1]'></div>
          </div>
        </div>
      </div>
    </div>
  )
}
